import React, { useState, useEffect } from 'react';
import HeroHome from '../components/HeroHome';
import Footer from '../components/Footer';

function App() {
    // State to keep track of the screen width
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    // Set up an event listener to detect screen size changes
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Extracting the primary images from each project
    const backgroundImages = screenWidth <= 767 ? [
        { path: 'mobile_hero1.jpg', name: 'Langkawi' },
        { path: 'mobile_hero2.jpg', name: 'Nanjing' }
    ] : [
        { path: 'hero1.jpg', name: 'Banyan Tree' },
        { path: 'hero2.jpg', name: 'Heritage' }
    ];

    return (
        <div className="bg-[#e5dedb] min-h-screen">
            <HeroHome images={backgroundImages} />
            <Footer />
        </div>
    );
}

export default App;
